import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import { LinkButton } from "components/buttons";
import { handleOpenPdf } from "utils";
import pds from "assets/pdf/PDS - Retail Cashline-i.pdf";

function Cashline() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Financing"
          title={`
              <div style="display: inline-flex; align-items: baseline;">
                <span className="jumbotron-subtitle-2">
                 Cashline
                    </span><i>-i</i>
            </div>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Initial deposit</div>
                <div className="column-subheader">RM500</div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Cheque book</div>
                <div className="column-subheader">
                  alrajhi bank Malaysia chequebook available upon request{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Shariah standards</div>
                <div className="column-subheader">
                  Compliance with alrajhi bank Malaysia’s Shariah standards
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Currency</div>
                <div className="column-subheader">Available in MYR</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Cashline Facility-<i>i</i> provides standby credit facility more
              often than not used for working capital needs to meet short term
              cash flow requirements. This credit facility offers flexibility
              with utilization allowed up to the maximum facility limit approved
              via the customer’s Current Account-i maintained with the Bank.
            </p>
            <p>Favourable features of the facility:-</p>
            <p>
              1. Revolving nature with flexibility of utilization operated
              through the customer’s Current Account-i.<br></br>
              2. Profit payable based on actual utilized amount only.<br></br>
              3. No Commitment Fee on unutilized limit.<br></br>
              4. Tenure of up to ten (10) years, subject to periodic reviews.
              <br></br>
              5. Shariah Compliant.
            </p>

            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
            <div className="link-button-row pt-5">
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() => handleOpenPdf(pds)}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Cashline;
